/**
 * SmartdineNow API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';

import { RestaurantBranchTableEntity } from '../model/restaurantBranchTableEntity';
import { SmartDineResponseRestaurantBranchTableEntity } from '../model/smartDineResponseRestaurantBranchTableEntity';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';


@Injectable()
export class RestaurantBranchTableRestControllerService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createRestaurantBranchTable(body: RestaurantBranchTableEntity, restaurantId: string, restaurantBranchId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseRestaurantBranchTableEntity>;
    public createRestaurantBranchTable(body: RestaurantBranchTableEntity, restaurantId: string, restaurantBranchId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseRestaurantBranchTableEntity>>;
    public createRestaurantBranchTable(body: RestaurantBranchTableEntity, restaurantId: string, restaurantBranchId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseRestaurantBranchTableEntity>>;
    public createRestaurantBranchTable(body: RestaurantBranchTableEntity, restaurantId: string, restaurantBranchId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createRestaurantBranchTable.');
        }

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling createRestaurantBranchTable.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling createRestaurantBranchTable.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseRestaurantBranchTableEntity>('post',`${this.basePath}/api/admin/restaurants/${encodeURIComponent(String(restaurantId))}/branches/${encodeURIComponent(String(restaurantBranchId))}/tables`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param tableId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateRestaurantBranchTable(body: RestaurantBranchTableEntity, restaurantId: string, restaurantBranchId: string, tableId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseRestaurantBranchTableEntity>;
    public updateRestaurantBranchTable(body: RestaurantBranchTableEntity, restaurantId: string, restaurantBranchId: string, tableId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseRestaurantBranchTableEntity>>;
    public updateRestaurantBranchTable(body: RestaurantBranchTableEntity, restaurantId: string, restaurantBranchId: string, tableId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseRestaurantBranchTableEntity>>;
    public updateRestaurantBranchTable(body: RestaurantBranchTableEntity, restaurantId: string, restaurantBranchId: string, tableId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateRestaurantBranchTable.');
        }

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling updateRestaurantBranchTable.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling updateRestaurantBranchTable.');
        }

        if (tableId === null || tableId === undefined) {
            throw new Error('Required parameter tableId was null or undefined when calling updateRestaurantBranchTable.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseRestaurantBranchTableEntity>('put',`${this.basePath}/api/admin/restaurants/${encodeURIComponent(String(restaurantId))}/branches/${encodeURIComponent(String(restaurantBranchId))}/tables/${encodeURIComponent(String(tableId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param tableId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteRestaurantBranchTable(restaurantId: string, restaurantBranchId: string, tableId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseRestaurantBranchTableEntity>;
    public deleteRestaurantBranchTable(restaurantId: string, restaurantBranchId: string, tableId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseRestaurantBranchTableEntity>>;
    public deleteRestaurantBranchTable(restaurantId: string, restaurantBranchId: string, tableId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseRestaurantBranchTableEntity>>;
    public deleteRestaurantBranchTable(restaurantId: string, restaurantBranchId: string, tableId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling deleteRestaurantBranchTable.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling deleteRestaurantBranchTable.');
        }

        if (tableId === null || tableId === undefined) {
            throw new Error('Required parameter tableId was null or undefined when calling deleteRestaurantBranchTable.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseRestaurantBranchTableEntity>('delete',`${this.basePath}/api/admin/restaurants/${encodeURIComponent(String(restaurantId))}/branches/${encodeURIComponent(String(restaurantBranchId))}/tables/${encodeURIComponent(String(tableId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param tableId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRestaurantBranchTable(restaurantId: string, restaurantBranchId: string, tableId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseRestaurantBranchTableEntity>;
    public getRestaurantBranchTable(restaurantId: string, restaurantBranchId: string, tableId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseRestaurantBranchTableEntity>>;
    public getRestaurantBranchTable(restaurantId: string, restaurantBranchId: string, tableId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseRestaurantBranchTableEntity>>;
    public getRestaurantBranchTable(restaurantId: string, restaurantBranchId: string, tableId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling getRestaurantBranchTable.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling getRestaurantBranchTable.');
        }

        if (tableId === null || tableId === undefined) {
            throw new Error('Required parameter tableId was null or undefined when calling getRestaurantBranchTable.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseRestaurantBranchTableEntity>('get',`${this.basePath}/api/admin/restaurants/${encodeURIComponent(String(restaurantId))}/branches/${encodeURIComponent(String(restaurantBranchId))}/tables/${encodeURIComponent(String(tableId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRestaurantBranchTables1(restaurantId: string, restaurantBranchId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseRestaurantBranchTableEntity>;
    public getRestaurantBranchTables1(restaurantId: string, restaurantBranchId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseRestaurantBranchTableEntity>>;
    public getRestaurantBranchTables1(restaurantId: string, restaurantBranchId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseRestaurantBranchTableEntity>>;
    public getRestaurantBranchTables1(restaurantId: string, restaurantBranchId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling getRestaurantBranchTables1.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling getRestaurantBranchTables1.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseRestaurantBranchTableEntity>('get',`${this.basePath}/api/admin/restaurants/${encodeURIComponent(String(restaurantId))}/branches/${encodeURIComponent(String(restaurantBranchId))}/tables`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
